export default __webpack_public_path__ + "images/LN.5ef8e94.png";